module.exports = __webpack_public_path__ + "img/img37.47b8213a.png";